import axiosInstance from ".";

export const fetchBenefits= () =>
  axiosInstance.get(`/v1/benefits`);

export const fetchBenefit = (id) =>
  axiosInstance.get(`/v1/benefits/${id}`);

export const fetchBenefitWithPartner = (id) =>
  axiosInstance.get(`/v1/benefits/${id}/partner`);


// Distinct benefit categories, used as the options of the category filter.
export const fetchBenefitCategories = () =>
  axiosInstance.get(`/v1/benefits/categories`);

// "category" is a value from fetchBenefitCategories (omit for all categories);
// "sort" is either "topRated" (default) or "latest".
export const fetchUserBenefits = ({ category, sort } = {}) =>
  axiosInstance.get(`v1/benefits/dashboard`, {
    params: {
      ...(category ? { category } : {}),
      ...(sort ? { sort } : {}),
    },
  })